var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-btn",style:(_vm.style),attrs:{"name":_vm.name,"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('loading-animation'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }